"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var Observable_1 = require("rxjs/Observable");
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var of_1 = require("rxjs/observable/of");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var ChangeLogService = /** @class */ (function () {
    function ChangeLogService(store, kbService, classifierService, http) {
        this.store = store;
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.http = http;
        this.$changeLogUrl = skynet_store_properties_api_1.getProperties(this.store).pipe(operators_1.map(function (properties) { return lodash_1.get(properties, 'entity-service-url'); }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, new skynet_store_utilities_1.StoreManagerError('Url for entity-service-url was not found')));
        this.$wfUrl = skynet_store_properties_api_1.getProperties(this.store).pipe(operators_1.map(function (properties) { return lodash_1.get(properties, 'workflow-service-url'); }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, new skynet_store_utilities_1.StoreManagerError('Url for workflow-service-url was not found')));
    }
    ChangeLogService.prototype.storeAllChangeLogs = function (category, instanceId, userId, loadCount) {
        var _this = this;
        return this.$changeLogUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/changelog/" + category + "/" + instanceId + "/" + userId);
        }), operators_1.map(function (data) {
            var allWfChanges = [];
            var packageCount = Math.floor(data.length / loadCount) + 1;
            for (var i = 1; i <= packageCount; i++) {
                var currentSlice = data.slice((i - 1) * loadCount, i * loadCount > data.length ?
                    data.length : i * loadCount);
                localStorage.setItem("log_" + i, JSON.stringify(currentSlice));
            }
            return packageCount;
        }));
    };
    ChangeLogService.prototype.getDiffView = function (category, instanceId, userId, firstVersion, secondVersion, languageId) {
        var _this = this;
        return this.$changeLogUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/diff/" + category + "/" + instanceId + "/" + userId + "/" + firstVersion + "/" + secondVersion);
        }), operators_1.switchMap(function (diffView) {
            return _this.kbService.getAllMetaGroups(category).pipe(operators_1.switchMap(function (groups) { return _this.getSubEntityMap(category).pipe(operators_1.map(function (subEntityMap) {
                return {
                    groups: groups,
                    subEntityMap: subEntityMap
                };
            })); })).pipe(operators_1.map(function (data) {
                return {
                    groups: data.groups,
                    subEntityMap: data.subEntityMap,
                    diffView: diffView
                };
            }));
        }), operators_1.switchMap(function (data) {
            var diffGroups = data.groups.map(function (group) {
                var groupName = group.getDisplayNameMultilingual().getValue(languageId);
                var rows = group.getMetaFields().filter(function (field) { return !field.getIsSystemField(); })
                    .map(function (field) { return _this.collectDiffRowData(field, data.diffView, data.subEntityMap, languageId); })
                    .filter(lodash_1.negate(lodash_1.isNil));
                return {
                    groupName: groupName,
                    rows: rows,
                    groupContainsUnEqualRows: !lodash_1.isNil(rows.find(function (row) { return row.rowContainsUnEqualChildRows || !row.equal; })),
                    expanded: true
                };
            });
            console.log(diffGroups);
            return _this.deserializeDiffView(diffGroups, languageId);
            // return Observable.of(diffGroups);
        }));
    };
    ChangeLogService.prototype.getStates = function (category) {
        var _this = this;
        return skynet_store_kb_api_1.categoryStoreManager()
            .selectOne(this.store, category)
            .pipe(operators_1.first(), operators_1.switchMap(function (metaCategory) {
            return lodash_1.isNil(metaCategory.wfProcessId)
                ? of_1.of([])
                : _this.$wfUrl.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + "/states?processId=" + metaCategory.wfProcessId); }), operators_1.map(function (states) {
                    return states.map(function (state) {
                        return {
                            id: state['id'],
                            processId: state['processId'],
                            name: state['name'],
                        };
                    });
                }));
        }));
    };
    ChangeLogService.prototype.getSubEntityMap = function (category) {
        var _this = this;
        return this.kbService.getMetaFields(category).pipe(operators_1.switchMap(function (fields) {
            var subEntityFields = fields.filter(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY; });
            return !lodash_1.isEmpty(subEntityFields) ? _this.subFieldData(subEntityFields) : Observable_1.Observable.of([]);
        }), operators_1.map(function (data) {
            var result = new Map();
            data.forEach(function (item) { return result.set(item['key'], item['fields']); });
            return result;
        }));
    };
    ChangeLogService.prototype.deserializeDiffView = function (groups, currentLanguageId) {
        var _this = this;
        var groups$ = [];
        groups.forEach(function (group) {
            var groupRows$ = [];
            groupRows$.push.apply(groupRows$, group.rows.map(function (row) {
                return _this.deSerializeDataRow(row, currentLanguageId)
                    .pipe();
            }));
            if (!lodash_1.isEmpty(groupRows$)) {
                groups$.push(combineLatest_1.combineLatest(groupRows$).pipe(operators_1.first(), operators_1.map(function (groupRows) {
                    group.rows = groupRows;
                    return group;
                })));
            }
        });
        return !lodash_1.isEmpty(groups$) ? combineLatest_1.combineLatest(groups$).pipe(operators_1.first()) : Observable_1.Observable.of([]);
    };
    ChangeLogService.prototype.deSerializeSubGroup = function (subGroup, currentLanguageId) {
        var _this = this;
        return !lodash_1.isEmpty(subGroup.rows) ?
            combineLatest_1.combineLatest(subGroup.rows.map(function (row) { return _this.deSerializeDataRow(row, currentLanguageId); })).pipe(operators_1.map(function () {
            }), operators_1.first()) : Observable_1.Observable.of();
    };
    ChangeLogService.prototype.deSerializeDataRow = function (dataRow, currentLanguageId) {
        var _this = this;
        if (dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
            return this.deSerializeClassifierRow(dataRow);
        }
        if (dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
            return !lodash_1.isEmpty(dataRow.childGroups) ? combineLatest_1.combineLatest(dataRow.childGroups.map(function (subGroup) { return _this.deSerializeSubGroup(subGroup, currentLanguageId); })).pipe(operators_1.map(function () { return dataRow; }), operators_1.first()) : Observable_1.Observable.of(dataRow);
        }
        else if (dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE
            || dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE_TIME
            || dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE
            || dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME) {
            if (!lodash_1.isNil(dataRow.firstVersionValue)) {
                dataRow.firstVersionValue = new Date(dataRow.firstVersionValue).toUTCString();
            }
            if (!lodash_1.isNil(dataRow.secondVersionValue)) {
                dataRow.secondVersionValue = new Date(dataRow.secondVersionValue).toUTCString();
            }
        }
        else if (dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING) {
            return this.deSerializeAccountingRow(dataRow, currentLanguageId);
        }
        else if (dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.MONEY) {
            return this.deSerializeMoneyRow(dataRow, currentLanguageId);
        }
        else if (dataRow.field.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
            return this.deSerializeMultiLingualRow(dataRow, currentLanguageId);
        }
        return Observable_1.Observable.of(dataRow);
    };
    ChangeLogService.prototype.deSerializeMultiLingualRow = function (multiLingualRow, currentLanguageId) {
        return this.store.select(function (_state) { return _state.languages.languages; }).pipe(operators_1.map(function (languages) {
            languages.map(function (language) {
                multiLingualRow.fieldPartRows.filter(function (part) { return Number(part.fieldName) === language.getId(); })
                    .forEach(function (part) {
                    part.fieldName = language.getName().getValue(currentLanguageId);
                });
            });
            return multiLingualRow;
        }));
    };
    ChangeLogService.prototype.deSerializeMoneyRow = function (moneyRow, currentLanguageId) {
        return skynet_store_currencies_api_1.currencyStoreManager
            .selectAll(this.store).pipe(operators_1.map(function (currencies) {
            var currencyPart = moneyRow.fieldPartRows.find(function (fieldPart) { return fieldPart.fieldName === 'Currency'; });
            if (!lodash_1.isNil(currencyPart)) {
                currencyPart.firstVersionValue =
                    currencies.filter(function (currency) { return currency.id === Number(currencyPart.firstVersionValue); })
                        .map(function (currency) { return currency.name[currentLanguageId]; }).first();
                currencyPart.secondVersionValue =
                    currencies.filter(function (currency) { return currency.id === Number(currencyPart.secondVersionValue); })
                        .map(function (currency) { return currency.name[currentLanguageId]; }).first();
            }
            return moneyRow;
        }));
    };
    ChangeLogService.prototype.deSerializeAccountingRow = function (accountingRow, currentLanguageId) {
        return skynet_store_currencies_api_1.currencyStoreManager
            .selectAll(this.store).pipe(operators_1.map(function (currencies) {
            var datePart = accountingRow.fieldPartRows.find(function (fieldPart) { return fieldPart.fieldName === 'Date'; });
            if (!lodash_1.isNil(datePart)) {
                datePart.firstVersionValue =
                    !lodash_1.isNil(datePart.firstVersionValue)
                        ? new Date(datePart.firstVersionValue).toUTCString() : datePart.firstVersionValue;
                datePart.secondVersionValue =
                    !lodash_1.isNil(datePart.secondVersionValue)
                        ? new Date(datePart.secondVersionValue).toUTCString() : datePart.secondVersionValue;
            }
            var currencyPart = accountingRow.fieldPartRows.find(function (fieldPart) { return fieldPart.fieldName === 'Currency'; });
            if (!lodash_1.isNil(currencyPart)) {
                currencyPart.firstVersionValue =
                    currencies.filter(function (currency) { return currency.id === Number(currencyPart.firstVersionValue); })
                        .map(function (currency) { return currency.name[currentLanguageId]; }).first();
                currencyPart.secondVersionValue =
                    currencies.filter(function (currency) { return currency.id === Number(currencyPart.secondVersionValue); })
                        .map(function (currency) { return currency.name[currentLanguageId]; }).first();
            }
            return accountingRow;
        }));
    };
    ChangeLogService.prototype.deSerializeClassifierRow = function (classifierRow) {
        return this.getClassifierNames(classifierRow.field.getCompoundCategorySystemName(), classifierRow.firstVersionValue, classifierRow.secondVersionValue).pipe(operators_1.map(function (names) {
            classifierRow.firstVersionValue = names[0];
            classifierRow.secondVersionValue = names[1];
            return classifierRow;
        }));
    };
    ChangeLogService.prototype.getClassifierNames = function (classifierCategory, firstId, secondId) {
        var _this = this;
        var names$ = [];
        if (!lodash_1.isNil(firstId) && !isNaN(Number(firstId))) {
            names$.push(this.classifierService.loadClassifiersByIds(classifierCategory, [Number(firstId)]).pipe(operators_1.switchMap(function (response) {
                if (!lodash_1.isNil(response.getData()[0])) {
                    return _this.classifierService.getEntityName(classifierCategory, response.getData()[0]);
                }
                return of_1.of('');
            })));
        }
        else {
            names$.push(of_1.of(''));
        }
        if (!lodash_1.isNil(secondId) && !isNaN(Number(secondId))) {
            names$.push(this.classifierService.loadClassifiersByIds(classifierCategory, [Number(secondId)]).pipe(operators_1.switchMap(function (response) {
                if (!lodash_1.isNil(response.getData()[0])) {
                    return _this.classifierService.getEntityName(classifierCategory, response.getData()[0]);
                }
                return of_1.of('');
            })));
        }
        else {
            names$.push(of_1.of(''));
        }
        return combineLatest_1.combineLatest(names$).pipe(operators_1.first());
    };
    ChangeLogService.prototype.collectDiffRowData = function (metaField, rawDiffViewData, subEntityMap, languageId) {
        var foundRawRow = rawDiffViewData.find(function (diffItem) { return diffItem['systemName'] === metaField.getSystemName(); });
        if (!lodash_1.isNil(foundRawRow)) {
            var childRows = metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY ?
                this.collectChildDiffRows(metaField, foundRawRow['childRows'], subEntityMap, languageId) :
                [];
            return {
                equal: foundRawRow['equal'],
                fieldName: metaField.getDisplayNameMultilingual().getValue(languageId),
                firstVersionValue: this.isComplexField(metaField) ? '' : foundRawRow['firstVersionValue'],
                secondVersionValue: this.isComplexField(metaField) ? '' : foundRawRow['secondVersionValue'],
                childGroups: childRows,
                expanded: false,
                rowContainsUnEqualChildRows: !lodash_1.isNil(childRows.find(function (childRow) { return childRow.subGroupContainsUnEqualRows; })),
                field: metaField,
                fieldPartRows: this.handleComplexFieldRow(metaField, foundRawRow)
            };
        }
    };
    ChangeLogService.prototype.isComplexField = function (metaField) {
        return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING
            || metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MONEY
            || metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING;
    };
    ChangeLogService.prototype.handleComplexFieldRow = function (metaField, parentRawRow) {
        if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
            if (!lodash_1.isNil(parentRawRow['firstVersionValue']) && !lodash_1.isNil(parentRawRow['secondVersionValue'])) {
                var firsValue_1 = parentRawRow['firstVersionValue'];
                var secondValue_1 = parentRawRow['secondVersionValue'];
                return lodash_1.keys(parentRawRow['firstVersionValue']).map(function (key) {
                    return {
                        equal: firsValue_1[key] === secondValue_1[key],
                        fieldName: key,
                        firstVersionValue: firsValue_1[key],
                        secondVersionValue: secondValue_1[key],
                        childGroups: [],
                        expanded: false,
                        rowContainsUnEqualChildRows: false,
                        field: metaField,
                        fieldPartRows: []
                    };
                });
            }
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MONEY) {
            if (!lodash_1.isNil(parentRawRow['firstVersionValue']) && !lodash_1.isNil(parentRawRow['secondVersionValue'])) {
                var firsValue = parentRawRow['firstVersionValue'];
                var secondValue = parentRawRow['secondVersionValue'];
                var result = [];
                result.push({
                    equal: firsValue['amount'] ===
                        secondValue['amount'],
                    fieldName: 'Amount',
                    firstVersionValue: firsValue['amount'],
                    secondVersionValue: secondValue['amount'],
                    childGroups: [],
                    expanded: false,
                    rowContainsUnEqualChildRows: false,
                    field: metaField,
                    fieldPartRows: []
                });
                result.push({
                    equal: firsValue['currencyId'] ===
                        secondValue['currencyId'],
                    fieldName: 'Currency',
                    firstVersionValue: firsValue['currencyId'],
                    secondVersionValue: secondValue['currencyId'],
                    childGroups: [],
                    expanded: false,
                    rowContainsUnEqualChildRows: false,
                    field: metaField,
                    fieldPartRows: []
                });
                return result;
            }
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING) {
            if (!lodash_1.isNil(parentRawRow['firstVersionValue']) && !lodash_1.isNil(parentRawRow['secondVersionValue'])) {
                var firsValue = parentRawRow['firstVersionValue'];
                var secondValue = parentRawRow['secondVersionValue'];
                var result = [];
                result.push({
                    equal: firsValue['timestamp'] === secondValue['timestamp'],
                    fieldName: 'Date',
                    firstVersionValue: firsValue['timestamp'],
                    secondVersionValue: secondValue['timestamp'],
                    childGroups: [],
                    expanded: false,
                    rowContainsUnEqualChildRows: false,
                    field: metaField,
                    fieldPartRows: []
                });
                result.push({
                    equal: firsValue['rateToDefault'] ===
                        secondValue['rateToDefault'],
                    fieldName: 'Rate',
                    firstVersionValue: firsValue['rateToDefault'],
                    secondVersionValue: secondValue['rateToDefault'],
                    childGroups: [],
                    expanded: false,
                    rowContainsUnEqualChildRows: false,
                    field: metaField,
                    fieldPartRows: []
                });
                result.push({
                    equal: (lodash_1.isNil(firsValue['originalMoney']) &&
                        lodash_1.isNil(secondValue['originalMoney']))
                        ||
                            (firsValue['originalMoney']['amount'] === secondValue['originalMoney']['amount']),
                    fieldName: 'Amount',
                    firstVersionValue: lodash_1.isNil(firsValue['originalMoney']) ? '' :
                        firsValue['originalMoney']['amount'],
                    secondVersionValue: lodash_1.isNil(secondValue['originalMoney']) ? '' :
                        secondValue['originalMoney']['amount'],
                    childGroups: [],
                    expanded: false,
                    rowContainsUnEqualChildRows: false,
                    field: metaField,
                    fieldPartRows: []
                });
                result.push({
                    equal: (lodash_1.isNil(firsValue['originalMoney']) &&
                        lodash_1.isNil(secondValue['originalMoney']))
                        || (firsValue['originalMoney']['currencyId'] ===
                            secondValue['originalMoney']['currencyId']),
                    fieldName: 'Currency',
                    firstVersionValue: lodash_1.isNil(firsValue['originalMoney']) ? '' :
                        firsValue['originalMoney']['currencyId'],
                    secondVersionValue: lodash_1.isNil(secondValue['originalMoney']) ? '' :
                        secondValue['originalMoney']['currencyId'],
                    childGroups: [],
                    expanded: false,
                    rowContainsUnEqualChildRows: false,
                    field: metaField,
                    fieldPartRows: []
                });
                return result;
            }
        }
        return [];
    };
    ChangeLogService.prototype.collectChildDiffRows = function (subField, childRawDiffViewData, subEntityMap, languageId) {
        var _this = this;
        return childRawDiffViewData.map(function (childRawRow) {
            var rows = [];
            subEntityMap.get(subField.getSystemName()).forEach(function (sbField) {
                var row = _this.collectDiffRowData(sbField, childRawRow['rows'], subEntityMap, languageId);
                if (!lodash_1.isNil(row)) {
                    rows.push(row);
                }
            });
            return {
                rowName: subField.getCompoundCategorySystemName(),
                firstIsEmpty: childRawRow['firstIsEmpty'],
                secondIsEmpty: childRawRow['secondIsEmpty'],
                rows: rows,
                subGroupContainsUnEqualRows: !lodash_1.isNil(rows.find(function (row) { return row.rowContainsUnEqualChildRows || !row.equal; })),
                expanded: false,
                subEntityField: subField
            };
        });
    };
    ChangeLogService.prototype.subFieldData = function (subFields) {
        var _this = this;
        var data$ = subFields.map(function (subEntityField) {
            return _this.kbService.getMetaFields(subEntityField.getCompoundCategorySystemName())
                .pipe(operators_1.map(function (metaFields) {
                return {
                    key: subEntityField.getSystemName(),
                    fields: metaFields
                };
            }));
        });
        return combineLatest_1.combineLatest(data$).pipe(operators_1.first());
    };
    ChangeLogService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [store_1.Store,
            idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            http_1.HttpClient])
    ], ChangeLogService);
    return ChangeLogService;
}());
exports.ChangeLogService = ChangeLogService;
var OperationType;
(function (OperationType) {
    OperationType["CREATE"] = "CREATE";
    OperationType["UPDATE"] = "UPDATE";
    OperationType["WORKFLOW"] = "WORKFLOW";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
//# sourceMappingURL=change-log.service.js.map